import { NgModule } from "@angular/core";
import { TfResultCheckboxComponent } from "./components/result-checkbox.component";
import { TfCheckboxModule } from "@app/modules/tf-checkbox";
import { FormsModule } from "@angular/forms";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";

@NgModule({
    declarations: [
        TfResultCheckboxComponent
    ],
    imports: [
        TfCheckboxModule,
        FormsModule,
        NgbPopover
    ],
    exports: [TfResultCheckboxComponent]
})
export class TfResultCheckboxModule {
}
